var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSection2ItemBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 79,
    viewBox: "0 0 129 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.73 10.32L1 75H69.63C72.9705 74.9993 76.2551 74.1422 79.17 72.5105C82.0849 70.8789 84.5328 68.5272 86.28 65.68L126 1H57.38C54.0395 1.00072 50.7549 1.85784 47.84 3.48949C44.9251 5.12114 42.4772 7.47284 40.73 10.32V10.32Z",
    stroke: "url(#paint0_linear_916_360)",
    strokeOpacity: 0.8,
    strokeMiterlimit: 10,
    strokeDasharray: "3 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.73 14.32L3.01001 79H71.63C74.9694 78.9994 78.2529 78.1434 81.1676 76.5136C84.0823 74.8838 86.5309 72.5347 88.28 69.69L128.01 5H59.38C56.0395 5.00072 52.755 5.85784 49.84 7.48949C46.9251 9.12114 44.4772 11.4728 42.73 14.32V14.32Z",
    fill: "#323232"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_360",
    x1: 151.335,
    y1: 38,
    x2: 41.7308,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781D95",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6E1D92",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#521E89",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#261F7A",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152075"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2ItemBackground);
export default __webpack_public_path__ + "static/media/section2itemBackground.179166be96c07e34e525bae5c379887d.svg";
export { ForwardRef as ReactComponent };